import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import moment from "moment";
import {alertActions, messageActions, organizationActions} from "../../_actions";
import {reduxForm} from "redux-form";
import {queryStringToObject} from "../../_helpers";
import {Button, Col, Form, Row} from "react-bootstrap";
import SummaryItem from "../SummaryPage/SummaryItem";
import DatetimeRangePicker from "react-bootstrap-daterangepicker";
import CircularProgress from '@mui/material/CircularProgress';
import styles from "./Styles.module.css"
import BasicFilterSelect from "../v2/common/BasicFilterSelect";

class MessagesRequiringAction extends Component {
  constructor(props) {
    super(props);
    const search = this.props.location.search.substring(1);
    const filterParams = queryStringToObject(search);

    filterParams.startDate = filterParams.startDate ?
      moment(filterParams.startDate) :
      moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    filterParams.endDate = filterParams.endDate ?
      moment(filterParams.endDate) :
      moment().add(1, 'd').format('YYYY-MM-DD HH:mm:ss');


    this.state = {
      filterParams: {
        organization: filterParams.organization ? filterParams.organization : '',
        ...filterParams
      },
    };
  }

  componentDidMount() {
    const {dispatch} = this.props;
    const visibility = ['PUBLIC', 'FEATURED', 'PRIVATE'];
    dispatch(organizationActions.getActiveOrganizations({visibility}));
  }

  handleOrganizationUpdateForm = (data) => {
    this.setState((prevState) => {
      return {
        filterParams: {
          ...prevState.filterParams,
          organization: data
        },
      }
    });
  }

  handleDatePickerUpdate = (event, data) => {
    this.setState((prevState) => {
      return {
        filterParams: {
          ...prevState.filterParams, ...{
            startDate: data.startDate.format('YYYY-MM-DD HH:mm:ss'),
            endDate: data.endDate.format('YYYY-MM-DD HH:mm:ss'),
          }
        }
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { organization, startDate, endDate } = this.state.filterParams;
    const { dispatch } = this.props;
    if (!organization) {
      dispatch(alertActions.error("Organization filed is required"));
      return;
    }
    dispatch(messageActions.getMessagesRequiringAction({...{organization: organization.id}, startDate, endDate }));
  }

  renderMessageRequiringActionSummary = (messagesRequiringActionSummary) => {
    let {trendsMessageCount, teamsMessageCount} = messagesRequiringActionSummary;
    trendsMessageCount = trendsMessageCount != null ? trendsMessageCount : '-';
    teamsMessageCount = teamsMessageCount!= null ? teamsMessageCount : '-';

    return (
      <div className={`shadow-border margin-right-500 ${styles["summaryContainer"]}`}>
        <Row className={`text-center ${styles["m2Percent"]}`}>
          <Col md={4} className={styles.borderRightGrey}>
            <SummaryItem value={trendsMessageCount} label="New trends message count"/>
          </Col>
          <Col md={4}>
            <SummaryItem value={teamsMessageCount} label="New teams message count"/>
          </Col>
        </Row>
      </div>
    );
  }

  mapLabelAndValueToOrg = (item) => {
    return {id: item.id, name: item.name};
  }

  render() {
    const { organization, startDate, endDate } = this.state.filterParams;
    const { organizations, messagesRequiringActionSummary, loading } = this.props;
    const input = {
      onChange: this.handleOrganizationUpdateForm, onBlur: () => {
      }
    };
    let setStartDate = moment(startDate).format('M/D/YYYY');
    const setEndDate = moment(endDate).format('M/D/YYYY');

    return (
      <Fragment>
        <div className={`container-pane ${styles["px38"]}`}>
          <div className="side-bar-pane shadow-border">
            <Form onSubmit={this.handleSubmit}>
              <span className="font-14 color-grey-dark">Organization</span>
              <div className={styles.orgSelect}>
                <BasicFilterSelect
                    placeHolder="Select Organization"
                    options={organizations ? organizations.map(this.mapLabelAndValueToOrg) : []}
                    onChange={input.onChange}
                />

              </div>
              <div>
                <span className="font-14 color-grey-dark">Date</span>
                <span className="calendar-today tms-inbox-calendar display-block">
                                <DatetimeRangePicker
                                  startDate={setStartDate}
                                  endDate={setEndDate}
                                  onEvent={this.handleDatePickerUpdate}>
                                    <input className="input-popup color-grey-dark font-14 tms-ellipsis"
                                           type="text"
                                           name="date-picker"
                                           placeholder={`${setStartDate} - ${setEndDate}`}
                                    />
                                </DatetimeRangePicker>
                            </span>
              </div>
              <div className={styles.mt20}>
                <Button className="btn btn-success btn-block font-15" type="submit" disabled={loading}>
                  Apply
                </Button>
              </div>
            </Form>
          </div>
        </div>
        <div className="container-right header-pane-without-border-lines">
          { loading ?
            <div className={`shadow-border margin-right-500 ${styles["loaderContainer"]}`}>
              <CircularProgress color={'primary'} size={40}/>
            </div>
            : this.renderMessageRequiringActionSummary(messagesRequiringActionSummary) }
        </div>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  const {organizations: { activeOrganizations }, messages: { messagesRequiringActionSummary, loading }} = state;
  return {
    organizations: activeOrganizations.organizations,
    loading,
    messagesRequiringActionSummary,
  };
}


MessagesRequiringAction = connect(mapStateToProps)(MessagesRequiringAction);
const messagesRequiringAction = reduxForm({
  form: 'MessagesRequiringAction'
})(MessagesRequiringAction);
export {messagesRequiringAction as MessagesRequiringAction};